module.exports = __webpack_public_path__ + "media/favicon/android-chrome-512x512-2c0da8cca110fff9a8779aea4b5c11ef.png";